;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _TimerComponent = require('./TimerComponent.vue');

var _TimerComponent2 = _interopRequireDefault(_TimerComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { TimerComponent: _TimerComponent2.default },
    props: ["csrf_token", "send_otp_url", "api_login_url", "agent_login_url"],
    data: function data() {
        return {
            step: 1,
            selected_user: {},
            changeset: {},
            timerRunning: false,
            minutes: "",
            seconds: ""
        };
    },
    methods: {
        capitalizeOTP: function capitalizeOTP(event) {
            this.selected_user.otp = event.target.value.toUpperCase();
        },

        updateTimer: function updateTimer(val) {
            this.timerRunning = val;
        },
        reset_view: function reset_view() {
            this.step = 1;
        },
        admin_signin: function admin_signin() {
            var self = this;
            if (!this.selected_user.email) {
                self.changeset = {
                    message: "Oops, something went wrong.",
                    email: "Can't be blank"
                };
            } else {
                _axios2.default.post(self.send_otp_url, {
                    _csrf_token: self.csrf_token,
                    email: self.selected_user.email,
                    type: "admin"
                }).then(function (response) {
                    if (response.data.status === "ok") {
                        self.step = 2;
                        self.timerRunning = true;
                        self.selected_user = response.data.user;
                    } else {
                        self.step == 1;
                        self.timerRunning = false;
                        self.changeset = response.data.errors;
                    }
                }).catch(function (error) {
                    self.changeset = { message: error };
                });
            }
        },
        agent_signin: function agent_signin() {
            var self = this;
            if (!this.selected_user.email) {
                self.changeset = {
                    message: "Oops, something went wrong.",
                    email: "Can't be blank"
                };
            } else {
                _axios2.default.post(self.send_otp_url, {
                    _csrf_token: self.csrf_token,
                    email: self.selected_user.email,
                    type: "agent"
                }).then(function (response) {
                    if (response.data.status === "ok") {
                        self.step = 3;
                        self.timerRunning = true;
                        self.selected_user = response.data.user;
                    } else {
                        self.timerRunning = false;
                        self.changeset = response.data.errors;
                    }
                }).catch(function (error) {
                    self.changeset = { message: error };
                });
            }
        },
        verify_login: function verify_login() {
            var self = this;
            _axios2.default.post(self.api_login_url, {
                otp: self.selected_user.otp,
                email: self.selected_user.email
            }).then(function (response) {
                if (response.data.status === "ok") {
                    location.assign(response.data.redirect);
                } else {
                    self.step = 2;
                    self.changeset = response.data.changeset;
                }
            }).catch(function (error) {
                self.changeset = { message: error };
            });
        },
        verify_agent_login: function verify_agent_login() {
            var self = this;
            _axios2.default.post(self.agent_login_url, {
                pin: self.selected_user.pin,
                otp: self.selected_user.otp,
                email: self.selected_user.email
            }).then(function (response) {
                if (response.data.status === "ok") {
                    location.assign(response.data.redirect);
                } else {
                    self.step = 3;
                    self.changeset = response.data.changeset;
                }
            }).catch(function (error) {
                self.changeset = error;
            });
        }
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"method":"POST"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[(_vm.step == 1)?_c('div',[(_vm.changeset.message != null)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.changeset.message))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email or Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.email),expression:"selected_user.email"}],staticClass:"form-control",class:{ 'is-invalid': 'email' in _vm.changeset },attrs:{"type":"text","name":"email","required":"","autofocus":""},domProps:{"value":(_vm.selected_user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "email", $event.target.value)}}}),_vm._v(" "),('email' in _vm.changeset)?_c('div',{staticClass:"invalid-feedback"},[_c('span',[_vm._v(_vm._s(_vm.changeset.email))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-block btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.admin_signin}},[_vm._v("Admin Signin")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-block btn-outline-success",attrs:{"type":"button"},on:{"click":_vm.agent_signin}},[_vm._v("Agent Signin")])])])]):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('label',{attrs:{"for":"otp"}},[_vm._v("Enter OTP")]),_vm._v(" "),(_vm.step == 2 && _vm.timerRunning)?_c('p',[_c('TimerComponent',{on:{"update:timer":_vm.updateTimer}})],1):_c('a',{attrs:{"href":"#"},on:{"click":_vm.reset_view}},[_vm._v("OTP expired. Resend OTP?")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.otp),expression:"selected_user.otp"}],staticClass:"form-control",class:{ 'is-invalid': 'otp' in _vm.changeset },attrs:{"type":"text","name":"otp","required":"","autofocus":""},domProps:{"value":(_vm.selected_user.otp)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "otp", $event.target.value)},_vm.capitalizeOTP]}}),_vm._v(" "),('otp' in _vm.changeset)?_c('div',{staticClass:"invalid-feedback"},[_c('span',[_vm._v(_vm._s(_vm.changeset.otp))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-block btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.verify_login}},[_vm._v("Submit")])])]):_vm._e(),_vm._v(" "),(_vm.step == 3)?_c('div',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"pin"}},[_vm._v("Enter PIN")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.pin),expression:"selected_user.pin"}],staticClass:"form-control",class:{ 'is-invalid': 'pin' in _vm.changeset },attrs:{"type":"password","name":"pin","required":"","autofocus":""},domProps:{"value":(_vm.selected_user.pin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "pin", $event.target.value)}}}),_vm._v(" "),('pin' in _vm.changeset)?_c('div',{staticClass:"invalid-feedback"},[_c('span',[_vm._v(_vm._s(_vm.changeset.pin))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"otp"}},[_vm._v("Enter OTP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_user.otp),expression:"selected_user.otp"}],staticClass:"form-control",class:{ 'is-invalid': 'otp' in _vm.changeset },attrs:{"type":"text","name":"otp","required":"","autofocus":""},domProps:{"value":(_vm.selected_user.otp)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected_user, "otp", $event.target.value)},_vm.capitalizeOTP]}}),_vm._v(" "),(_vm.step == 3 && _vm.timerRunning)?_c('p',[_c('TimerComponent',{on:{"update:timer":_vm.updateTimer}})],1):_vm._e(),_vm._v(" "),('otp' in _vm.changeset)?_c('div',{staticClass:"invalid-feedback"},[_c('span',[_vm._v(_vm._s(_vm.changeset.pin))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-block btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.verify_agent_login}},[_vm._v("Submit")])])]):_vm._e()])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ef99a06", __vue__options__)
  } else {
    hotAPI.reload("data-v-3ef99a06", __vue__options__)
  }
})()}